import axios from 'axios'
import _get from 'lodash/get'

import { handleRequestError } from './request'

export const REQUEST_EMPLOYMENT_BENEFITS = 'REQUEST_EMPLOYMENT_BENEFITS'
export const RECEIVE_EMPLOYMENT_BENEFITS = 'RECEIVE_EMPLOYMENT_BENEFITS'

export const requestEmploymentBenefits = (employmentId) => (dispatch) => {
    dispatch({ type: REQUEST_EMPLOYMENT_BENEFITS, data: { employmentId } })

    axios
        .get(`/employment/${employmentId}/employmentbenefits`)
        .then((response) => {
            const responseData = _get(response, ['data'], [])

            dispatch(
                receiveEmploymentBenefits({
                    fetchSuccessful: true,
                    items: responseData,
                })
            )
        })
        .catch((error) => {
            dispatch(receiveEmploymentBenefits({ fetchSuccessful: false }))
            dispatch(handleRequestError(error))
        })
}

export const receiveEmploymentBenefits = (data) => ({ type: RECEIVE_EMPLOYMENT_BENEFITS, data })
